export default __webpack_public_path__ + "static/2295-4a26a1d26bd0485e11c6621b07a3e742.gif";